jQuery(document).ready(function($) {
  animatedSection.init();
  loadMorePosts.init();
  utility.init();
  quantityInput.init();

  require('./components/mobile-header.js')
  require('./components/accordion.js')
  require('./components/video.js')
  require('./components/slider.js')
  require('./components/search.js')
});

var animatedSection = {
  init: function() {
    jQuery(window).scroll(function() {

      jQuery('#animated-section').each(function() {
        var animatedSection = jQuery(this)

        var scrollOffset = animatedSection.offset().top - 1000;
        var windowLocation =  jQuery(window).scrollTop()

        if(windowLocation >= scrollOffset && !animatedSection.hasClass()) {
          animatedSection.addClass('active')
        }
      })
    })
  },
}

var loadMorePosts = {
  init: function() {
    jQuery('#load-more').click(function(){
        loadMorePosts.loadMore();

    });
  },

  loadMore: function() {
    var loadContainer = jQuery('#load-container');
    var postCount = jQuery('#load-container .item').length;
    var totalPosts = loadContainer.data('total');
    var args = loadContainer.data('args');
    var productType = loadContainer.data('product-type');

    if(postCount >= totalPosts) {
      return;
    }

    var data = {
      action: 'load_more_posts',
      post_count: postCount,
      post_args: args,
      product_type: productType,
      post_search: posts.s,
    };

    jQuery.ajax({
      url: posts.ajaxurl,
      type: "POST",
      data: data,
      beforeSend: function () {

      // Request for posts

        jQuery('#load-more').addClass('loading');
      },
      complete: function () {

          // Request for posts received / response is being sent back to us

          jQuery('#load-more').removeClass('loading');

        },
        success: function(data) {

          // We get posts back / successful response

          if(data) {
            loadContainer.append(data);
          }

          postCount = jQuery('#load-container .item').length;

          if(postCount >= totalPosts) {
            jQuery('#load-more').replaceWith('<a class="no-posts" href="#load-container">Back to top <i class="fas fa-long-arrow-up"></i></a>');
          }

          utility.hashAnimate();

          return;
        }
    });
  }
}

var quantityInput = {
  init: function() {
    jQuery('.product-info .quantity').each(function() {
      var input, btnUp, btnDown, min, max

      input = jQuery(this).find('input')
      btnUp = jQuery('.quantity-up')
      btnDown = jQuery('.quantity-down')
      min = input.attr('min'),
      max = input.attr('max');

      btnUp.click(function() {
        var oldValue = parseFloat(input.val());

        if (max && oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }

        input.val(newVal);
        input.trigger("change");
      })

      btnDown.click(function() {
        var oldValue = parseFloat(input.val());

        if (min && oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }

        input.val(newVal);
        input.trigger("change");
      })
    })
  },
}

// Smooth Scroll
var utility = {
  init: function() {
      utility.hashAnimate();
  },

  hashAnimate: function() {
    jQuery('a[href^="#"]').click(function(e) {
        e.preventDefault();

        var localHash = jQuery(this).attr('href');
        var scrollOffset = jQuery('header').outerHeight();

        if(jQuery(localHash).offset()) {
          jQuery("html, body").animate({
            scrollTop: jQuery(localHash).offset().top - scrollOffset - 140
          }, 200);
        }
    });
  }
}
